"use client";

import {JSX} from "react";

import {type SpaceProps, useSectionSpace} from "@/sections/use-section-space";

import {type ThingToDoItem} from "@/entities/destination/attraction/types";

import {useModel} from "@/shared/hooks/state-management/use-model";
import {ContainerBase} from "@/shared/ui/layout/container-base";

import {ThingsToDoList} from "./parts/things-to-do-list";
import {type TagOption, ThingsToDo} from "./things-to-do.model";

import "./styles/things-to-do.scss";

export type ThingsToDoSectionProps = SpaceProps & {
    items: ReadonlyArray<ThingToDoItem>;
    tags: ReadonlyArray<TagOption>;
    location?: string;
    title?: string;
};

export function ThingsToDoSection({items, tags, ...space}: ThingsToDoSectionProps): JSX.Element {
    const sectionSpace = useSectionSpace(space);

    const [model] = useModel(ThingsToDo, {tags, items});

    return (
        <section className="things-to-do" aria-label="Things to do list" style={sectionSpace}>
            <ContainerBase>
                {/*<ThingsToDoFilters location={location} title={title} model={model} />*/}
                <ThingsToDoList model={model} />
            </ContainerBase>
        </section>
    );
}
